import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Modal, ModalCard } from 'apps/shared/scripts/components';
import { closeModal, ModalTypes } from 'apps/shared/scripts/redux';
import {
  selectIsCardPostModalVisible,
  selectModalType,
} from 'apps/shared/scripts/redux/selectors';

import CardPostFormContainer from '../CardPostFormContainer';

const CardPostModalContainer = () => {
  const { cardId } = useParams();
  const isModalVisible = useSelector(selectIsCardPostModalVisible);
  const modalType = useSelector(selectModalType);
  const dispatch = useDispatch();

  const isEditMode = modalType === ModalTypes.EditCardPost;

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  return (
    <Modal closeModal={handleClose} isVisible={isModalVisible}>
      <ModalCard>
        <CardPostFormContainer
          closeModal={handleClose}
          isEditMode={isEditMode}
          cardId={cardId!}
        />
      </ModalCard>
    </Modal>
  );
};

CardPostModalContainer.displayName = 'CardPostModalContainer';

export default CardPostModalContainer;
